import React from "react";
import Masthead01 from '../Masthead01';
import './style.scss'

const Masthead03 = (props) => {
  return(
    <Masthead01 {...props} filtersSearch={true}/>
  )
}

export default Masthead03